<ng-container *ngIf="showPricesTable; else noPrices">
  <table
    mat-table
    [dataSource]="prices$ | async"
    [testId]="testIds.PRODUCT_PRICES_TABLE"
  >
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef>Product</th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/product', element.product_id, { type: 'hire' }]">{{
          element.product_name
        }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="prices">
      <th mat-header-cell *matHeaderCellDef>Price</th>
      <td mat-cell *matCellDef="let element">
        <prices-display [prices]="element.prices"></prices-display>
      </td>
    </ng-container>
  </table>
</ng-container>
<ng-template #noPrices>
  <div
    [testId]="testIds.NO_PRODUCT_PRICES"
    class="flex flex-col flex-grow-1 items-center justify-center py-12"
  >
    <p>
      <em>No customer specific prices have been set up for this customer.</em>
    </p>
  </div>
</ng-template>
